import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import Lottie from 'lottie-react';

const LottiePlayer = ({ path, fallback, size = 220 }) => {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    if (!path) {
      setData(null);
      setFailed(false);
      return;
    }
    let cancelled = false;
    fetch(path)
      .then((res) => (res.ok ? res.json() : Promise.reject(new Error('not found'))))
      .then((json) => { if (!cancelled) setData(json); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [path]);

  if (!path || failed) return fallback || null;
  if (!data) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {fallback}
      </Box>
    );
  }
  return (
    <Box sx={{ width: size, height: size }}>
      <Lottie animationData={data} loop autoplay />
    </Box>
  );
};

export default LottiePlayer;
